import ContractConditions from './contract-conditions-container';

export default ContractConditions;